import React from 'react';

import './FeedatyWidget.scss';

const FeedatyWidget = () => {
  return (
    <div className="feedaty">
      {/* NEW V3.0.0 */}
      <div
        class="feedaty_widget"
        data-type="carousel"
        data-variant="carosello-2"
        data-id="selettore1"
        data-gui="all"
        data-lang="all"
      ></div>
    </div>
  );
};

export default FeedatyWidget;
